import displayObject from '@/mixins/display-object.js'
import { Container } from 'pixi.js'

export default {
  mixins: [
    displayObject
  ],

  props: {
    x: {
      type: Number,
      default: 0
    },

    y: {
      type: Number,
      default: 0
    },

    width: {
      type: Number,
      default: 16
    },

    height: {
      type: Number,
      default: 16
    }
  },

  computed: {
    displayObject () {
      return new Container()
    }
  },

  render (h) {
    return this.$slots.default
      ? h('div', this.$slots.default)
      : undefined
  },

  methods: {
    updateProp () {
      return true
    }
  },

  watch: {
    displayObject: {
      handler (newObj, oldObj) {
        if (oldObj && oldObj.parent) oldObj.parent.removeChild(oldObj) // remove old instance
        if (this.$parent.displayObject) this.$parent.displayObject.addChild(newObj) // add new instance

        // Set properties
        for (let key in this.$props) {
          if (this.updateProp(key, this.$props[key])) continue
          if (newObj[key] === undefined) continue
          if (this.$props[key] === undefined) continue

          newObj[key] = this.$props[key]
        }
      },
      immediate: true
    },

    '$props': {
      handler (props) {
        for (let key in props) {
          if (this.updateProp(key, this.$props[key])) continue
          if (this.displayObject[key] === undefined) continue
          if (props[key] === undefined) continue

          this.displayObject[key] = props[key]
        }
      },
      deep: true
    }
  }
}
